import { render } from "./ownerSuccess.vue?vue&type=template&id=7d6b4f4b&scoped=true&ts=true"
import script from "./ownerSuccess.vue?vue&type=script&lang=ts"
export * from "./ownerSuccess.vue?vue&type=script&lang=ts"

import "./ownerSuccess.vue?vue&type=style&index=0&id=7d6b4f4b&scoped=true&lang=css"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d6b4f4b"]])

export default __exports__